// The knowledge bank's claims off the wire (GET /v1/claims and the grounding
// read's statement backing), parsed at the boundary.

import type {
    Claim,
    ClaimLink,
    ClaimPassage,
} from "../../components/ClaimRow/ClaimRow.js";
import { bool, fields, list, num, str } from "../wireShape.js";

// One claim off the wire, parsed at the boundary: a claim without an id or
// wording drops, and so does a passage or link missing a field.
const parsePassage = (raw: unknown): ClaimPassage[] => {
    const f = fields(raw);
    const sourceId = str(f?.get("sourceId"));
    const exact = str(f?.get("exact"));
    const page = num(f?.get("page"));
    if (sourceId === undefined || exact === undefined) return [];
    return [
        {
            sourceId,
            sourceTitle: str(f?.get("sourceTitle")) ?? "",
            exact,
            ...(page === undefined ? {} : { page }),
            located: bool(f?.get("located")),
        },
    ];
};

const parseLink = (raw: unknown): ClaimLink[] => {
    const f = fields(raw);
    const type = str(f?.get("type"));
    const id = str(f?.get("id"));
    const label = str(f?.get("label"));
    return (type === "concept" ||
        type === "objective" ||
        type === "audience") &&
        id !== undefined &&
        label !== undefined
        ? [{ type, id, label }]
        : [];
};

export const parseClaim = (raw: unknown): Claim[] => {
    const f = fields(raw);
    const claimId = str(f?.get("claimId"));
    const wording = str(f?.get("wording"));
    if (claimId === undefined || wording === undefined) return [];
    return [
        {
            claimId,
            wording,
            byAgent: bool(f?.get("byAgent")),
            links: list(f?.get("links")).flatMap(parseLink),
            backing: list(f?.get("backing")).flatMap(parsePassage),
        },
    ];
};
